import {Component, Input, OnInit} from '@angular/core';
import {CandidatureFormation} from '../../candidature-formation.model';
import {ParametrageService} from '../../../parametrage';
import {Response} from '@angular/http';
import {CONSTANTS} from '../../../../cadens.constants';
import {Composant, GrhumService} from '../../../grhum';
import {FormationService, Question} from '../../../formation';
import {FormationComponentService} from '../formationComponent.service';

@Component({
    selector: 'jhi-master-component',
    templateUrl: 'master.component.html'
})
export class MasterComponent implements OnInit {

    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() isEditable: Boolean;
    @Input() questions: Question[];
    @Input() currentLang: string;
    @Input() isBO: number;

    parametrage: any;
    mentionsListe: Composant[];
    parcoursListe: Composant[];
    niveauxListe: Composant[];
    private filterByParcours = false;
    constants = CONSTANTS;
    isSaving = false;
    isGradeLicence = false;
    ageLimiteBourse: Date | null = null;
    isEligibleBourse  =false;

    constructor(private parametrageService: ParametrageService,
                private grhumService: GrhumService,
                private formationService: FormationService,
                private formationComponentService: FormationComponentService,
    ) {
    }

    ngOnInit() {
        this.parametrageService.query({page: CONSTANTS.MASTER}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        // Récupération de la date limite de bourse
        this.parametrageService.queryAgeLimiteBourseExc().subscribe(
            (res: Response) => {
                const parametrages = res.json();
                if (parametrages && parametrages.length > 0) {
                    const parametrage = parametrages[0];
                    // Utilise libelle ou libelleEn selon la langue
                    const dateLibelle = this.currentLang === 'fr' ? parametrage.libelle : parametrage.libelleEn;
                    console.log('Valeur brute de libelle :', dateLibelle);

                    if (dateLibelle) {
                        try {

                            // Parse la date selon le format attendu (exemple : "JJ/MM/AAAA")
                            const dateParts = dateLibelle.split('/');
                            if (dateParts.length === 3) {
                                const day = parseInt(dateParts[0], 10);
                                const month = parseInt(dateParts[1], 10) - 1; // Les mois commencent à 0 en JavaScript
                                const year = parseInt(dateParts[2], 10);
                                if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                                    this.ageLimiteBourse = new Date(year, month, day);
                                    console.log('Date limite bourse :', this.ageLimiteBourse);
                                    // Calcul de l'éligibilité
                                    // Comparaison des dates
                                    if (this.candidatureFormation.dateNaissance) {
                                        const birthDate = new Date(this.candidatureFormation.dateNaissance);
                                        this.isEligibleBourse = birthDate >= this.ageLimiteBourse;
                                        //this.candidatureFormation.bourseExcellence = false;
                                        //this.candidatureFormation.indicBourseExcellence = false;
                                        console.log('Date de naissance :', birthDate, 'Eligible :', this.isEligibleBourse);
                                    }
                                } else {
                                    console.error('Format de date invalide dans libelle :', dateLibelle);
                                }
                            } else {
                                console.error('Format de date inattendu dans libelle :', dateLibelle);
                            }
                        } catch (e) {
                            console.error('Erreur lors du parsing de la date :', e);
                        }
                    }
                }
            },
            (error) => {
                console.error('Erreur lors de la récupération de la date limite de bourse :', error);
            }
        );
        // Chargement des listes de Mentions, parcours & niveaux
        this.getListeMentions(this.candidatureFormation.parcoursId);
        this.getListeParcours(this.candidatureFormation.mentionId);
        if (this.candidatureFormation.parcoursId) {
            this.getListeNiveaux(this.candidatureFormation.parcoursId);
        }

        if (this.candidatureFormation.ei != this.constants.NON_CONCERNE) {
            this.candidatureFormation.fc = false;
        }
    }
    onChangeBourseIndicExcellence() {
        if (this.candidatureFormation.indicBourseExcellence == false) {
            this.candidatureFormation.bourseExcellence = false;
        }
    }
    onChangeMention(newMention) {
        this.isGradeLicence = false;
        if (typeof newMention === 'string') {
            newMention = null;
            this.candidatureFormation.mentionId = null;
        }

        if (this.candidatureFormation.mentionId) {
            const composantMention = this.mentionsListe.filter(value => value.idComposant === this.candidatureFormation.mentionId);
            if (composantMention) {
                this.isGradeLicence = composantMention[0].grade === 1;
            }
        }

        this.candidatureFormation.formationId = null;
        if (this.filterByParcours && this.candidatureFormation.niveauId !== null) {
            this.findFormation(this.candidatureFormation.niveauId);
        }
        if (!this.filterByParcours || this.candidatureFormation.parcoursId == null) {
            this.niveauxListe = [];
            this.getListeParcours(newMention);
            if (newMention == null) {
                this.getListeMentions(this.candidatureFormation.formationId);
            }
            this.filterByParcours = false;
        }
    }



    onChangeParcours(newParcours) {
        if (typeof newParcours === 'string') {
            newParcours = null;
            this.candidatureFormation.parcoursId = null;
        }
        this.candidatureFormation.formationId = null;
        this.candidatureFormation.niveauId = null;
        this.niveauxListe = [];
        this.getListeNiveaux(newParcours);
        if (this.candidatureFormation.mentionId == null || this.filterByParcours) {
            this.filterByParcours = true;
            this.getListeMentions(newParcours);
        } else {
            this.filterByParcours = false;
        }
    }

    // Once candidat has choosen Master + Parcours + Niveau, get the corresponding formation id
    findFormation(newNiveau) {
        if (newNiveau == null || typeof newNiveau === 'string') {
            this.candidatureFormation.formationId = null;
            this.candidatureFormation.niveauId = null;
            newNiveau = null;
        }
        if (this.candidatureFormation.mentionId && this.candidatureFormation.niveauId && this.candidatureFormation.parcoursId) {
            this.isSaving = true;
            this.formationService.query({
                mentionId: this.candidatureFormation.mentionId,
                parcoursId: this.candidatureFormation.parcoursId,
                niveauId: newNiveau
            }).subscribe(
                (res: Response) => {
                    let formation = res.json();
                    this.candidatureFormation.formationId = formation[0].id;
                    this.candidatureFormation.libelle = formation[0].libelle;
                    this.formationComponentService.changeFormation(this.candidatureFormation.formationId);
                    this.isSaving = false;
                }, (res: Response) => {
                    this.isSaving = false;
                });
        }
    }


    selectionFormationContinue(fc: boolean) {
        this.formationComponentService.changeFc(fc);
    }

    private getListeMentions(parcoursId) {
        this.grhumService.queryComposant({
            type: CONSTANTS.MENTION,
            typeCampagne: CONSTANTS.MASTER ,
            childId: parcoursId,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(
            (res: Response) => {
                this.mentionsListe = res.json();
                if (this.mentionsListe != null && this.mentionsListe.length === 1) {
                    this.candidatureFormation.mentionId = this.mentionsListe[0].idComposant;
                    this.isGradeLicence = this.mentionsListe[0].grade === 1;
                    if (this.candidatureFormation.parcoursId == null) {
                        this.getListeParcours(this.candidatureFormation.mentionId);
                    } else {
                        this.getListeNiveaux(this.candidatureFormation.parcoursId);
                    }
                }
            });
    }

    private getListeParcours(mention) {
        let copyParcours = this.candidatureFormation.parcoursId;
        this.grhumService.queryComposant({
            type: CONSTANTS.PARCOURS,
            typeCampagne: CONSTANTS.MASTER ,
            parentId: mention,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(
            (res: Response) => {
                this.parcoursListe = res.json();
                if (mention == null) {
                    this.candidatureFormation.parcoursId = copyParcours;
                }
                if (this.parcoursListe != null && this.parcoursListe.length === 1) {
                    this.candidatureFormation.parcoursId = this.parcoursListe[0].idComposant;
                    this.getListeNiveaux(this.candidatureFormation.parcoursId);
                }
            });
    }

    private getListeNiveaux(parcours) {
        this.grhumService.queryComposant({
            type: CONSTANTS.NIVEAU,
            typeCampagne: CONSTANTS.MASTER ,
            parentId: parcours,
            mentionId: this.candidatureFormation.mentionId,
            reinscription: this.candidatureFormation.reinscription,
            ei: this.candidatureFormation.ei,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(
            (res: Response) => {
                this.niveauxListe = res.json();
                if (this.niveauxListe != null && this.niveauxListe.length === 1) {
                    this.candidatureFormation.niveauId = this.niveauxListe[0].idComposant;
                    this.findFormation(this.candidatureFormation.niveauId);
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/master/master.component.ts